import { purposeDataEnum, LEVEL } from '../enums/enums';

const renderTechnicalCheckbox = messageSettings => `
	<section class="cookies-settings__section">
	<header class="cookies-settings__section-header">
		<h3 class="cookies-settings__section-title">${ messageSettings.technicalTitle }</h3>
		<div class="cookies-settings__section-state-container">
			<span class="cookies-settings__section-state cookies-settings__section-state--on">${ messageSettings.technicalState }</span>
		</div>
	</header>
	<div class="cookies-settings__section-main">
		<p class="cookies-settings__section-perex">${ messageSettings.technicalPerex }</p>
	</div>
</section>
	`;

/**
 * purpose checkbox šablona
 */
const renderPurposeCheckbox = (messageSettings, purposeData, sectionClassName = '') => {
	const title = messageSettings[ `${ purposeData }Title` ];
	const perex = messageSettings[ `${ purposeData }Perex` ];

	// Výchozí content
	const defaultContent = `
<div class="cookies-settings__section-main">
	<p class="cookies-settings__section-perex">${ perex }</p>
</div>
`;

	// Pouze pro stav, kde je výpis analytického a marketingového nastavení v jednom
	const adAnalyticsContent = `
<div class="cookies-settings__section-main">
	<h4 class="cookies-settings__section-sub-title">${ messageSettings.analyticsTitle }</h4>
	<p class="cookies-settings__section-perex">${ messageSettings.analyticsPerex }</p>
</div>
<div class="cookies-settings__section-main">
	<h4 class="cookies-settings__section-sub-title">${ messageSettings.adTitle }</h4>
	<p class="cookies-settings__section-perex">${ messageSettings.adPerex }</p>
</div>
`;

	return `
<section class="cookies-settings__section ${ sectionClassName }">
	<header class="cookies-settings__section-header">
		<h3 class="cookies-settings__section-title">${ title }</h3>
		<div class="cookies-settings__section-state-container">
			<input id="${ purposeData }" class="cookies-settings__checkbox" type="checkbox" name="${ purposeData }" value="${ purposeData }" data-fragment="cp.settingsPurposeInput">
			<label class="cookies-settings__label cookies-settings__section-state" for="${ purposeData }"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">${ messageSettings.checkboxStateOff }</span></label>
		</div>
	</header>
	${ purposeData === purposeDataEnum.AD_ANALYTICS ? adAnalyticsContent : defaultContent }
</section>
`;
};

/**
 * recipient Accordion
 */
const renderRecipientAccordion = (messageAccordion, recipientData) => {
	const {
		level,
		messages,
	} = recipientData;

	const {
		tableData,
	} = messages;

	const {
		tableTypeTechnical,
		tableTypeAnalytics,
		tableTypeAd,
		tableTypeFunctionality,
		tableTypePersonalization,
		tableTypeSecurity,
	} = messageAccordion;

	let levelAlias;
	switch (Number(level)) {
		case LEVEL.TECHNICAL:
			levelAlias = tableTypeTechnical;
			break;
		case LEVEL.ANALYTICS:
			levelAlias = tableTypeAnalytics;
			break;
		case LEVEL.AD:
			levelAlias = tableTypeAd;
			break;
		case LEVEL.FUNCTIONALITY:
			levelAlias = tableTypeFunctionality;
			break;
		case LEVEL.PERSONALIZATION:
			levelAlias = tableTypePersonalization;
			break;
		case LEVEL.SECURITY:
			levelAlias = tableTypeSecurity;
			break;
		default:
			break;
	}

	const tableHead = ({
		tableTitle,
		tablePerex,
		tableType,
		tableExpire,
		tableWhoUse,
	}) => `
			<tr>
				<th>${ tableTitle }</th>
				<th>${ tablePerex }</th>
				<th>${ tableType }</th>
				<th>${ tableExpire }</th>
				<th>${ tableWhoUse }</th>
			</tr>
		`;

	const tableBody = (level, tableData) => [ ...tableData ].map(data => `
			<tr>
				<td>${ data.title }</td>
				<td>${ data.perex }</td>
				<td>${ level }</td>
				<td>${ data.expire }</td>
				<td>${ data.whoUse }</td>
			</tr>
	`).join('');

	return `
<div class="cookies__accordion">
	<button class="cookies__accordion-button" type="button" data-fragment="cp.accordionBtn">${ messageAccordion.btn }</button>
	<div class="cookies__accordion-content">
		<table class="cookies__accordion-table">
			<thead>
				${ tableHead(messageAccordion) }
			</thead>
			<tbody>
				${ tableBody(levelAlias, tableData) }
			</tbody>
		</table>
	</div>
</div>
`;
};

/**
 * recipient checkbox šablona
 */
const renderRecipientCheckbox = (messageSettings, messageAccordion, name, recipientData) => `
<section class="cookies-settings__section">
	<header class="cookies-settings__section-header">
		<h3 class="cookies-settings__section-title">${ recipientData.messages.title }</h3>
		<div class="cookies-settings__section-state-container">
			<input id="${ name }" class="cookies-settings__checkbox" type="checkbox" ${ recipientData.level === 2 ? 'disabled' : '' } name="${ name }" value="${ name }" data-fragment="cp.settingsRecipientInput">
			<label class="cookies-settings__label cookies-settings__section-state" for="${ name }"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">${ messageSettings.checkboxStateOff }</span></label>
		</div>
	</header>
	<div class="cookies-settings__section-main">
		<p class="cookies-settings__section-perex">${ recipientData.messages.perex }</p>
		${ recipientData.messages.tableData ? renderRecipientAccordion(messageAccordion, recipientData) : '' }
	</div>
</section>
`;

/**
 * výchozí šablona pro nastavení
 */
const renderSettingsTemplateDefault = messageSettings => renderTechnicalCheckbox(messageSettings) + renderPurposeCheckbox(messageSettings, purposeDataEnum.AD_ANALYTICS, 'cookies-settings__section--analytics-marketing');

/**
 * šablona pro - enableSplitGTMContainer:true + je využita pro enableComplexGTM props
 */
const renderSettingsTemplateSplit = messageSettings => renderTechnicalCheckbox(messageSettings) + renderPurposeCheckbox(messageSettings, purposeDataEnum.ANALYTICS) + renderPurposeCheckbox(messageSettings, purposeDataEnum.AD);

/**
 * šablona která se aplikuje při nastavení props - enableComplexGTM:true
 */
const renderSettingsTemplateComplex = (messageSettings, messageAccordion, recipientData, whiteListPurposeCheckbox) => {
	const renderWhiteListPurposeCheckbox = whiteListPurposeCheckbox => [ ...whiteListPurposeCheckbox ].map((item) => {
		switch (item) {
			case purposeDataEnum.FUNCTIONALITY:
				return renderPurposeCheckbox(messageSettings, purposeDataEnum.FUNCTIONALITY);
			case purposeDataEnum.PERSONALIZATION:
				return renderPurposeCheckbox(messageSettings, purposeDataEnum.PERSONALIZATION);
			case purposeDataEnum.SECURITY:
				return renderPurposeCheckbox(messageSettings, purposeDataEnum.SECURITY);
			default:
				break;
		}
	});
	const purposeTabContentTemplate = messageSettings => `
	<div id="purpose" class="cookies-settings__tab-content cookies-settings__tab-content--active">
		${ renderSettingsTemplateSplit(messageSettings) + renderWhiteListPurposeCheckbox(whiteListPurposeCheckbox) }
	</div>
	`;

	const recipientTabContentTemplate = (messageSettings, messageAccordion, recipientData) => `
	<div id="recipient" class="cookies-settings__tab-content">
		${ Object.entries(recipientData).map(([ key, value ]) => renderRecipientCheckbox(messageSettings, messageAccordion, key, value)).join('') }
	</div>
	`;

	return `
<section class="cookies-settings__tab">
	<div class="cookies-settings__tab-button-group">
		<button class="cookies-settings__tab-button cookies-settings__tab-button--active" data-fragment="cp.tabBtn" data-target="purpose">${ messageSettings.purposeTabBtn }</button>
		<button class="cookies-settings__tab-button" data-fragment="cp.tabBtn" data-target="recipient">${ messageSettings.recipientTabBtn }</button>
	</div>
	${ purposeTabContentTemplate(messageSettings) }
	${ recipientTabContentTemplate(messageSettings, messageAccordion, recipientData) }
</section>
`;
};

/**
 * šablona pro vykreslení buttons containeru v hlavičce
 */

const renderHeaderButtonsContainer = ({ acceptAllBtn }) => `
<div class="cookies-settings__buttons">
	<button class="cookies-settings__btn cookies-settings__btn--primary" data-fragment="cp.settingsAcceptAllBtn">${ acceptAllBtn }</button>
</div>
`;

/**
 * šablona pro vykreslení buttons containeru v patičce
 */
const renderFooterButtonsContainer = (
	{
		acceptAllBtn,
		acceptSelectedBtn,
		technicalBtn,
	},
	enableRenderModalFooterAcceptAllButton,
	enableRenderModalFooterAcceptSelectedButton,
	enableRenderModalFooterTechnicalButton
) => `
<div class="cookies-settings__footer">
	${ enableRenderModalFooterTechnicalButton ? `<button class="cookies-settings__btn cookies-settings__btn--technical" data-fragment="cp.settingsTechnicalBtn">${ technicalBtn }</button>` : '' }
	${ enableRenderModalFooterAcceptSelectedButton ? `<button class="cookies-settings__btn cookies-settings__btn--secondary" data-fragment="cp.settingsAcceptSelectedBtn">${ acceptSelectedBtn }</button>` : '' }
	${ enableRenderModalFooterAcceptAllButton ? `<button class="cookies-settings__btn cookies-settings__btn--primary" data-fragment="cp.settingsAcceptAllBtn">${ acceptAllBtn }</button>` : '' }
</div>
`;

/**
 * šablona ve které je logika pro vykreslení na základě podmínek
 */
export const renderSettingsTemplate = ({
	enableSplitGTMContainer,
	enableComplexGTM,
	enableRenderModalFooterButtonsContainer,
	enableRenderModalFooterAcceptAllButton,
	enableRenderModalFooterAcceptSelectedButton,
	enableRenderModalFooterTechnicalButton,
	enableRenderModalHeaderButtonsContainer,
	idSettings,
	whiteListPurposeCheckbox,
	messageAccordion,
	messageSettings,
	recipientData,
}) => `
<section id="${ idSettings }" class="cookies-settings" data-fragment="cp.settings">
	<div class="cookies-settings__container">
		<header class="cookies-settings__header">
			<button class="cookies-settings__btn-close" data-fragment="cp.settingsCloseBtn"><span class="cookies-settings__btn-close-text">${ messageSettings.closeBtn }</span></button>
			<h2 class="cookies-settings__heading">${ messageSettings.heading }</h2>
			<p class="cookies-settings__perex">${ messageSettings.perex }</p>
			${ enableRenderModalHeaderButtonsContainer ? renderHeaderButtonsContainer(messageSettings) : '' }
		</header>
		<div class="cookies-settings__main">
			${ (!enableComplexGTM && !enableSplitGTMContainer) ? renderSettingsTemplateDefault(messageSettings) : '' }
			${ enableSplitGTMContainer ? renderSettingsTemplateSplit(messageSettings) : '' }
			${ enableComplexGTM ? renderSettingsTemplateComplex(messageSettings, messageAccordion, recipientData, whiteListPurposeCheckbox) : '' }
		</div>
		${ enableRenderModalFooterButtonsContainer ? renderFooterButtonsContainer(messageSettings, enableRenderModalFooterAcceptAllButton, enableRenderModalFooterAcceptSelectedButton, enableRenderModalFooterTechnicalButton) : '' }
	</div>
</section>
`;



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/CookiesPolicy4/templates/settingsTemplate.js